module.exports = __webpack_public_path__ + "static/media/personas-cover-2.3595d974.png";